import { defineComponent as _defineComponent } from 'vue'
import FormField from './fields/FormField.vue';
import { FormModel } from '../interfaces/form';
import { computed, ref, defineAsyncComponent } from 'vue';
import { useFormElement } from '../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../composables/useFormElementInterfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: makeUseFormElementProps<FormModel>(),
  emits: makeUseFormElementEmits(),
  setup(__props, { emit }) {

const props = __props;

const RepeatForm = defineAsyncComponent(() => import('./RepeatForm.vue'));

const DynamicForm = defineAsyncComponent(() => import('./DynamicForm.vue'));





const item = ref<InstanceType<typeof FormField>>();

const { modelStateRef, getModelState, toggleModelState, model, field, emitFormEvent } = useFormElement({
  emit,
  props,
});

const isRepeatForm = modelStateRef('multiple', false);

const open = modelStateRef('open', false);

const isTogglable = modelStateRef('togglable');

const isSection = computed(() => getModelState('display') === 'section');

const title = modelStateRef('title');

function onSectionClick() {
  if (isSection.value && !open.value) {
    emitFormEvent({ event: 'form-section-select' });
  }
}

function toggle(event: Event) {
  toggleModelState('open');
  event.stopPropagation();
}

return { __sfc: true,RepeatForm, DynamicForm, props, emit, item, modelStateRef, getModelState, toggleModelState, model, field, emitFormEvent, isRepeatForm, open, isTogglable, isSection, title, onSectionClick, toggle }
}

})